module.exports = __webpack_public_path__ + "img/tata.bbd7820a.png";